module.exports = __webpack_public_path__ + "static/media/7.5ffe39d7.png";